import { loadStyle, loadScript } from './utils'

import {
  onError,
  postTime,
  startTimingEecords,
  closeTimingEecords,
  onLoadingTimeout,
  playStat,
  clearLoadingTimeout
} from './playerEvent'

import useTouchProgress from './touchProgress'

import { getPlatform } from 'src/frontend-lib/tools/getPlatform'

var defaultCover =
  'https://ossimg.xinli001.com/20181008/5a5a33197f293767f5d1f13b78174733.jpg'
// default options
var defaultOption = {
  vid: '',
  // playauth
  playauth: '',
  // 封面
  cover: defaultCover,
  url: '',
  // 'https://qianyi.xinli001.com/14d60919fc4c4d43a167de9f9149c1e9/488fc7ec94d944ce9f7722df0d59fb6d-b5446fd8d8bdc214b792724884e01f96-sd.m3u8',
  // 'https://mpv.videocc.net/605ea32bee/5/605ea32bee352f74472e757831242995_1.mp3',
  token: '',
  hash: '',
  ts: '',
  daily_lesson: '',
  isVideo: true,
  isAudio: false,
  isLive: false
}

/**
 * 生成窗口大小配置
 * @param { HTMLElement } el 视频节点
 * @returns { Object } { ratio, width, height }
 */
const genSize = el => {
  const ratio = 0.563
  if (el instanceof HTMLElement) {
    var width = el.clientWidth
    var height = width * 0.563
    return {
      ratio,
      width,
      height
    }
  }
  return {
    ratio,
    width,
    height
  }
}

const loadPlayer = () => {
  const verion = '2.9.23'
  // （必须）H5模式播放器，需引用此css文件
  const style = `https://g.alicdn.com/de/prismplayer/${verion}/skins/default/aliplayer-min.css`
  //（必须）引入H5模式的js文件。
  const playerUrl = `https://g.alicdn.com/de/prismplayer/${verion}/aliplayer-h5-min.js`

  const _version = window.Aliplayer && window.Aliplayer.getVersion()
  if (_version === verion) {
    // aliplayer exits
    return Promise.resolve()
  }

  return Promise.all([loadStyle(style), loadScript(playerUrl)])
}

/**
 * 默认合并
 * @param { object } target
 * @param  { ...object } sources
 * @returns { object }
 */
const defaultMerge = (target, ...sources) => {
  const result = Object.assign.apply(Object, [{}].concat(sources))
  for (const key in target) {
    const def = result[key]
    if (!def && typeof def !== 'number' && typeof def !== 'boolean') {
      result[key] = target[key]
    }
  }
  return result
}

/**
 * @param { Partial<defaultOption> } option video option
 * @returns { Object } options
 */
const genOption = (option, width) => {
  const _option = defaultMerge(defaultOption, option)
  const {
    url: source,
    cover,
    vid,
    token: playauth,
    isVideo,
    isAudio,
    isLive = false
  } = _option
  const component = window.AliPlayerComponent
  let components = [
    {
      name: component.RateComponent.name,
      type: component.RateComponent
    }
  ]
  if (isVideo) {
    components.push({
      name: 'qualityComponent',
      type: component.QualityComponent,
      args: [
        function(definition, desc) {
          console.log(definition + '-----' + desc)
        }
      ]
    })
  } else if (isAudio) {
    components.push({
      name: component.AudioCoverComponent.name,
      type: component.AudioCoverComponent,
      args: [cover]
    })
  }
  console.log('=== width >= 375 ===', width >= 375)
  if (width >= 375) {
    components.push({
      name: 'fastForwardComponent',
      type: component.FastForwardComponent,
      args: [postTime]
    })
  }

  return {
    vid,
    cover,
    source: isAudio ? source : '',
    playauth: isVideo ? playauth : '',
    // 配置
    isLive,
    rePlay: false,
    autoplay: false,
    preload: true,
    playsinline: true,
    mediaType: isVideo ? 'video' : 'audio', // audio | video
    useH5Prism: true,
    // 显示视频清晰度
    // definition: 'FD,LD,SD,HD,OD',
    x5_type: 'h5',
    x5_fullscreen: true,
    x5_video_position: 'center',
    x5_orientation: 'portrait', // BS播放器支持的方向
    showBarTime: 3000,
    controlBarVisibility: 'hover',
    format: isVideo ? 'm3u8' : '', // 播放地址格式
    isVBR: !!isVideo,
    qualitySort: 'desc',
    components: components,
    skinLayout: [
      { name: 'bigPlayButton', align: 'cc' },
      { name: 'H5Loading', align: 'cc' },
      { name: 'errorDisplay' },
      { name: 'thumbnail' },
      // { name: 'infoDisplay', align: 'tl', x: 15 },
      { name: 'tooltip', align: 'tl', x: 0, y: 10 },

      {
        name: 'controlBar',
        align: 'blabs',
        x: 0,
        y: 0,
        children: [
          { name: 'progress', align: 'tlabs', x: 0, y: -4 },
          { name: 'playButton', align: 'tl', x: 15, y: 12 },
          { name: 'timeDisplay', align: 'tl', x: 10, y: 6 },

          { name: 'fullScreenButton', align: 'tr', x: 15, y: 12 },
          // { name: 'setting', align: 'tr', x: 15, y: 12 },
          { name: 'volume', align: 'tr', x: 10, y: 10 }
        ]
      },

      {
        name: 'fullControlBar',
        align: 'tlabs',
        x: 0,
        y: 0,
        children: [
          { name: 'fullNormalScreenButton', align: 'tr', x: 24, y: 13 },
          { name: 'fullTimeDisplay', align: 'tr', x: 10, y: 12 }
        ]
      }
    ]
  }
}

/**
 * create aliPlayer
 * @param { string } el
 * @param { defaultOption } option video option
 * @param { object | undefined } config the more https://help.aliyun.com/document_detail/125572.html
 * }
 */
const handleInit = function(id, option, config) {
  const el = id instanceof HTMLElement ? id : document.getElementById(id)
  if (!(el instanceof HTMLElement))
    throw console.warn('Not found html element!')

  const self = this
  const { height, width } = self._getSize(el)

  // 移动小屏展示
  var controlBarVisibility = 'hover'
  if (width < 768) {
    controlBarVisibility = 'click'
  }

  self.$el = el
  const createPalyer = () =>
    new Promise((resolve, reject) => {
      const options = this._getOption(option, width)
      console.log('=== handleInit === options', options)
      let obj = Object.assign(
        options,
        { id: el.id, height: height + 'px', controlBarVisibility },
        config
      )
      try {
        new Aliplayer(obj, resolve)
      } catch (error) {
        // retry load
        const func =
          Aliplayer === undefined
            ? handleInit.bind(self, id, option)
            : createPalyer
        setTimeout(func, 10000)
        onError(error)
        reject(error)
      }
    })

  return this._load()
    .then(createPalyer)
    .then(player => {
      console.log('A player created!')
      return player
    })
}

const handleInitEvents = function(player) {
  const self = this
  const callFunc = (func, ...args) =>
    typeof func === 'function' && func.apply(player, args)
  const components = window.AliPlayerComponent
  const QualityComponent = player.getComponent('qualityComponent')
  const FastForwardComponent = player.getComponent('fastForwardComponent')

  /**
   * 跳转记录时间
   */
  player.on('ready', function(params) {
    const total = player.getDuration()
    const currentTime = window.baseInfo.play_time

    const { isYixinliApp } = getPlatform()
    if (!isYixinliApp) {
      player.seek(currentTime || 0)
    } else {
      const lested = Math.min(0, +total - 3000, currentTime)

      if (lested) {
        console.log('jumping lasted time:', lested)
        player.seek(lested)
      }
    }
  })

  player.on('requestFullScreen', () => {
    self.handleSize(player)
  })

  /**
   * 重置窗口大小
   */
  player.on('cancelFullScreen', () => {
    self.handleSize(player)
    self.resetScreen(player)
  })

  /**
   * 隐藏Thumbnail
   */
  player.on('hideBar', function() {
    // self.resetThumbnail(player)
  })
  player.on('completeSeek', function() {
    self.resetThumbnail(player)
  })

  player.on('ended', () => {
    // * 展示封面
    self.showCover()
  })

  /**
   * 上报处理
   */
  player.on('play', params => {
    callFunc(playStat)
    callFunc(startTimingEecords, true)
    QualityComponent &&
      QualityComponent.setCurrentPlayTime.call(QualityComponent, player)
  })
  player.on('pause', () => {
    callFunc(closeTimingEecords)
    callFunc(postTime, true)
  })
  player.on('ended', () => {
    callFunc(closeTimingEecords)
    callFunc(clearLoadingTimeout)
    callFunc(postTime)
    QualityComponent &&
      QualityComponent.resetCurrentPlayTime.call(QualityComponent, player)
  })
  player.on('waiting', onLoadingTimeout.bind(player, 5))
  player.on('completeSeek', postTime)
  player.on('error', onError)

  player.on('showBar', function() {
    // FastForwardComponent.visibleComponent.call(FastForwardComponent, player)
  })

  player.on('hideBar', function() {
    // FastForwardComponent.hideComponent.call(FastForwardComponent, player)
  })
}

// aliplayer native methods
const getTime = function() {
  const player = this.$player
  return player && player.getCurrentTime()
}

/**
 * 设置封面
 * @param {string} url 封面地址
 */
const setCover = function(url) {
  const player = this.$player
  const coverVm = player.getComponent(
    window.AliPlayerComponent.AudioCoverComponent.name
  )

  if (coverVm) {
    coverVm.setCover(url)
  }
  player.setCover(url)
}

const showCover = function() {
  const el = this.$el
  if (el instanceof HTMLElement) {
    const coverEl = el.querySelector('.prism-cover')
    coverEl && (coverEl.style.display = 'block')
  }
}

const resetScreen = function(player) {
  const { height } = this.getSize()
  if (player) {
    player.setPlayerSize('100%', String.prototype.concat.call(height, 'px'))
  }
}

const handleSize = function(player) {
  player.tag.style.height = '100%'
  player.tag.style.width = '100%'
}

/**
 * 视窗重置
 */
const onResizeWindow = () => {
  const { _instance, player } = playerState
  _instance &&
    [].concat(_instance).forEach(instacne => {
      window.clearTimeout(instacne.timeResizeId)
      instacne.timeResizeId = window.setTimeout(
        _instance.resetScreen.bind(_instance, player),
        800
      )
    })
}

const resetThumbnail = function() {
  const el = this.$el
  if (el instanceof HTMLElement) {
    const thumbnail = el.querySelector('.prism-thumbnail')
    if (
      thumbnail instanceof HTMLElement &&
      thumbnail.style.display !== 'none'
    ) {
      setTimeout(() => {
        thumbnail.removeAttribute('style')
      }, 300)
    }
  }
}

// static state
export const playerState = {
  _instance: null,
  _playTime: null,
  _isCreated: null,

  player: null
}

/**
 * set player state
 * @param { keyof playerState } key string
 * @param { any } value
 * @returns value
 */
export const setState = (key, value) => {
  if (key in playerState) {
    return (playerState[key] = value)
  }
}

/**
 *
 * @param { keyof playerState } key
 * @returns { undefined | playerState[key] }
 */
export const getState = key => {
  if (key in playerState) {
    return playerState[key]
  }
}

export class ALIPlayer {
  // state store
  static playerState = playerState

  get state() {
    return ALIPlayer.playerState
  }

  get $player() {
    return this.state.player
  }

  $el = null

  // methods
  initPlayer = handleInit
  initEvents = handleInitEvents
  initTouchProgess = useTouchProgress

  getState = getState
  setState = setState

  getTime = getTime
  setCover = setCover
  showCover = showCover

  /**
   * 获取生成的高度
   */
  getSize() {
    return this._getSize(this.$el)
  }
  /**
   * 重置视频窗口
   */
  resetScreen = resetScreen
  handleSize = handleSize

  /**
   * 重置thumbnail, 移动端不会隐藏情况
   */
  resetThumbnail = resetThumbnail

  // private methods
  _load = loadPlayer
  _getSize = genSize
  _getOption = genOption

  /**
   * player module
   * @param { string } el
   * @param { defaultOption } option
   */
  constructor(el, option) {
    console.log('------- Using Aliplayer -------\n')

    this.initPlayer(el, option).then(player => {
      this.setState('player', player)
      this.setState('_instance', this)
      this.setState('_isCreated', true)

      this.initEvents(player)
      this.initTouchProgess(player)
      // 视窗重置
      window.removeEventListener('resize', onResizeWindow)
      window.addEventListener('resize', onResizeWindow)
    })
  }
}

export default ALIPlayer



// WEBPACK FOOTER //
// ./src/pages/lesson/play/components/aliplayer/player.js